import { render, staticRenderFns } from "./ForeignCitiesGrid.vue?vue&type=template&id=2c1b380e"
import script from "./ForeignCitiesGrid.vue?vue&type=script&lang=js"
export * from "./ForeignCitiesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports